export function deleteScoreSearchParams(searchParams: URLSearchParams) {
  searchParams.delete('match_min');
  searchParams.delete('match_max');
  searchParams.delete('raw_potential_min');
  searchParams.delete('raw_potential_max');
  searchParams.delete('ocp_min');
  searchParams.delete('ocp_max');
  searchParams.delete('logic_min');
  searchParams.delete('logic_max');
  searchParams.delete('sjt_min');
  searchParams.delete('sjt_max');
  searchParams.delete('motivational_min');
  searchParams.delete('motivational_max');
  searchParams.delete('operational_logic');
}
